import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from './auth.module';
import { TrackingService, TrackingInterceptor } from '@vfde-fe/ngx-lib/plugins/tracking';

/** modules  */
@NgModule({
    imports: [CommonModule, AuthModule.forRoot()],
})
/** PluginsModule */
export class PluginsModule {
  /** forRoot */
    public static forRoot (): ModuleWithProviders<unknown> {
        return {
            ngModule: PluginsModule,
            providers: [
                TrackingInterceptor,
                TrackingService,
            ],
        };
    }
}
